import { LoadDownloads } from './downloads.actions';

export const DownloadsLoadingActions = [LoadDownloads];
